import { withLogger } from "@hyperapp/logger";
import { location as routerLocation } from "@hyperapp/router";
import { app as makeApp, ActionsType } from "hyperapp";

import * as actions from "./actions";
import { view } from "./view";
import { state } from "./state";
import * as translations from "./translations";

let app;

const startApp = () => {
  app = withLogger(makeApp)(
    state,
    (actions as unknown) as ActionsType<any, any>,
    view({ translations }),
    document.body,
  );

  routerLocation.subscribe(app.location);
};

if (window.parent && window.parent !== window) {
  window.addEventListener("message", event => {
    if (event.data.id === "41222495-2999-4e49-b103-8cf8541e61e6") {
      state.authorization = `Bearer ${event.data.token}`;
      state.clientID = event.data.clientID;
      let res = event.data.objectIntlConfigUser;
      let lang = res.language;
      state.intlObjectConfigUser = res;
      state.language = lang || "PT";
      startApp();
    }
  });

  window.parent.postMessage(
    {
      id: "41222495-2999-4e49-b103-8cf8541e61e6",
    },
    "*",
  );
} else {
  startApp();
}

// import { _$ } from "./_$";

// _$(app, true);
